var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SimpleTextPopup", {
    attrs: {
      title: _vm.$t("details"),
      hideRgtBtn: true,
      medium:
        (_vm.transaction.transactionType === "fee" &&
          _vm.transaction.subtype !== "other service") ||
        (["label-invoice", "adjust", "label"].includes(_vm.transaction.type) &&
          !!_vm.transaction.details),
      small:
        _vm.transaction.transactionType === "deposit" ||
        _vm.transaction.subtype === "other service" ||
        _vm.transaction.type === "deposit"
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            ["inbound", "outbound"].includes(_vm.transaction.subtype) &&
            _vm.transaction.note !== "custom"
              ? _c(
                  "v-layout",
                  [
                    _vm.isOldVersionData
                      ? _c(
                          "v-tooltip",
                          {
                            attrs: { top: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(tooltip) {
                                    return [
                                      _c(
                                        "v-flex",
                                        _vm._g(
                                          { attrs: { md3: "" } },
                                          tooltip.on
                                        ),
                                        [
                                          _c("v-text-field", {
                                            staticClass: "thinBox",
                                            attrs: {
                                              label: _vm.$t("packageFee"),
                                              readonly: "",
                                              outline: ""
                                            },
                                            model: {
                                              value: _vm.transaction.packageFee,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.transaction,
                                                  "packageFee",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "transaction.packageFee"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1507056743
                            )
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.$t("inboundPackageFeeDetail")) +
                                "\n      "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-flex", { attrs: { md2: "" } }),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { md3: "" } },
                      [
                        _c("v-text-field", {
                          staticClass: "thinBox",
                          attrs: {
                            label: _vm.$t("discountRate"),
                            readonly: "",
                            outline: "",
                            value: _vm.transaction.discountRate + "%"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-flex", { attrs: { md2: "" } }),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { md3: "" } },
                      [
                        _c("v-text-field", {
                          staticClass: "thinBox",
                          attrs: {
                            label: _vm.$t("totalPackageQuantity"),
                            readonly: "",
                            outline: ""
                          },
                          model: {
                            value: _vm.transaction.packageQty,
                            callback: function($$v) {
                              _vm.$set(_vm.transaction, "packageQty", $$v)
                            },
                            expression: "transaction.packageQty"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            (_vm.transaction.otherServices &&
              _vm.transaction.otherServices.length) ||
            _vm.transaction.warehouseNote
              ? _c(
                  "v-layout",
                  { attrs: { "align-center": "", "justify-start": "" } },
                  [
                    _c("v-flex", { attrs: { sm3: "", md2: "", xl1: "" } }, [
                      _vm._v(_vm._s(_vm.$t("otherServices")) + ": ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      _vm._l(_vm.transaction.otherServices, function(item) {
                        return _c("v-chip", { key: item }, [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                (
                                  _vm.otherServices.find(function(service) {
                                    return service.value === item
                                  }) || {}
                                ).displayName || item
                              ) +
                              "\n      "
                          )
                        ])
                      }),
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.transaction.subtype === "inbound" ||
            (_vm.transaction.subtype === "outbound" &&
              !_vm.transaction.billingDetails)
              ? _c("v-data-table", {
                  staticClass: "elevation-1",
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.transaction.items || _vm.transaction.products
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "items",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _vm.transaction.subtype === "inbound"
                              ? _c("td", { staticClass: "subheading" }, [
                                  _vm._v(_vm._s(item.trackings.join(", ")))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(_vm._s(item.upc))
                            ]),
                            _vm._v(" "),
                            !_vm.isOldVersionData
                              ? _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(item.packageFee))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(_vm._s(item.quantity))
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(
                                _vm._s(
                                  item.unitFee ||
                                    _vm.transaction.unitFee ||
                                    "N/A"
                                )
                              )
                            ])
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    198735361
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.transaction.subtype === "outbound" &&
            _vm.transaction.billingDetails
              ? _c("v-data-table", {
                  staticClass: "elevation-1",
                  attrs: {
                    headers: _vm.outboundDetailsHeaders,
                    items: Object.entries(_vm.transaction.billingDetails).map(
                      function(ref) {
                        var key = ref[0]
                        var item = ref[1]

                        return Object.assign({}, item, { key: key })
                      }
                    )
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "items",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(_vm._s(item.key))
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(_vm._s(item.quantity))
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(_vm._s(item.unit || 0))
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(_vm._s(item.total || 0))
                            ])
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    536869900
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.transaction.subtype === "storage"
              ? _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      { attrs: { md2: "" } },
                      [
                        _c("v-text-field", {
                          staticClass: "thinBox",
                          attrs: {
                            label: _vm.$t("discountRate"),
                            readonly: "",
                            outline: "",
                            value: _vm.transaction.discountRate + "%"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.transaction.subtype === "storage"
              ? _c("v-data-table", {
                  staticClass: "elevation-1",
                  attrs: { headers: _vm.headers, items: _vm.transaction.upcs },
                  scopedSlots: _vm._u(
                    [
                      _vm.transaction.note === "STORAGE_FEE_IN_INVENTORY_AGE"
                        ? {
                            key: "items",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c("td", { staticClass: "subheading" }, [
                                  _vm._v(_vm._s(item.upc))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(item.unitFee))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(item.quantity))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(
                                    _vm._s(_vm.toMoney(item.inventoryAge, 3))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(
                                    _vm._s(_vm.toMoney(item.billingWeight, 3))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(_vm.toMoney(item.amount, 3)))
                                ])
                              ]
                            }
                          }
                        : _vm.transaction.note === "autoConfirm"
                        ? {
                            key: "items",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c("td", { staticClass: "subheading" }, [
                                  _vm._v(_vm._s(item.upc))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(item.trackings.join(",")))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.toTimestampString(item.inboundTime)
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(item.quantity))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(_vm.toMoney(item.amount, 3)))
                                ])
                              ]
                            }
                          }
                        : {
                            key: "items",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c("td", { staticClass: "subheading" }, [
                                  _vm._v(_vm._s(item.upc))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(item.unitFee))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(item.quantity))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(_vm.toMoney(item.amount, 3)))
                                ])
                              ]
                            }
                          }
                    ],
                    null,
                    true
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.transaction.transactionType === "deposit" ||
            _vm.transaction.type === "deposit"
              ? _c(
                  "v-container",
                  { attrs: { fluid: "" } },
                  [
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs8: "", md6: "", lg5: "", xl4: "" } },
                          [_vm._v(_vm._s(_vm.$t("deposit")) + ": ")]
                        ),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs4: "" } }, [
                          _vm._v(
                            "$ " +
                              _vm._s(
                                _vm.toMoney(
                                  _vm.transaction.originDepositAmount ||
                                    _vm.transaction.amount
                                )
                              )
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.transaction.bonuses &&
                    _vm.transaction.bonuses.details.length > 0
                      ? _c(
                          "v-layout",
                          [
                            _c(
                              "v-flex",
                              { attrs: { xs8: "", md6: "", lg5: "", xl4: "" } },
                              [_vm._v(_vm._s(_vm.$t("bonus")) + ": ")]
                            ),
                            _vm._v(" "),
                            _c("v-flex", { attrs: { xs4: "" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.transaction.bonuses.details
                                    .map(function(item) {
                                      return "$ " + item.bonus
                                    })
                                    .join(" + ")
                                )
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs8: "", md6: "", lg5: "", xl4: "" } },
                          [_vm._v(_vm._s(_vm.$t("transactionFee")) + ": ")]
                        ),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs4: "" } }, [
                          _vm._v(
                            "$ " +
                              _vm._s(
                                _vm.transaction.transactionFee ||
                                  _vm.transaction.fee ||
                                  0
                              )
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.transaction.last4
                      ? _c(
                          "v-layout",
                          [
                            _c(
                              "v-flex",
                              { attrs: { xs8: "", md6: "", lg5: "", xl4: "" } },
                              [_vm._v(_vm._s(_vm.$t("cardNumber")) + ": ")]
                            ),
                            _vm._v(" "),
                            _c("v-flex", { attrs: { xs4: "" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.transaction.last4 &&
                                    "**** " + _vm.transaction.last4
                                )
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.transaction.cardType
                      ? _c(
                          "v-layout",
                          [
                            _c(
                              "v-flex",
                              { attrs: { xs8: "", md6: "", lg5: "", xl4: "" } },
                              [_vm._v(_vm._s(_vm.$t("cardType")) + ": ")]
                            ),
                            _vm._v(" "),
                            _c("v-flex", { attrs: { xs4: "" } }, [
                              _vm._v(_vm._s(_vm.transaction.cardType))
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs8: "", md6: "", lg5: "", xl4: "" } },
                          [_vm._v(_vm._s(_vm.$t("transactionTime")) + ": ")]
                        ),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs4: "" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.toTimestampString(_vm.transaction.createTime)
                            )
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs8: "", md6: "", lg5: "", xl4: "" } },
                          [_vm._v(_vm._s(_vm.$t("receiptEmail")) + ": ")]
                        ),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs4: "" } }, [
                          _vm._v(
                            _vm._s(_vm.transaction.receiptEmail || "Unknown")
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs8: "", md6: "", lg5: "", xl4: "" } },
                          [_vm._v(_vm._s(_vm.$t("status")) + ": ")]
                        ),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs4: "" } }, [
                          _vm._v(_vm._s(_vm.transaction.status || "Success"))
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.transaction.subType === "CreditcardProcessFee" &&
            _vm.transaction.type === "fee"
              ? _c(
                  "v-container",
                  { attrs: { fluid: "" } },
                  [
                    _c(
                      "v-layout",
                      { attrs: { "justify-center": "" } },
                      [
                        _c("v-flex", { attrs: { md4: "" } }, [
                          _vm._v(_vm._s(_vm.$t("amount")))
                        ]),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { md4: "" } }, [
                          _vm._v("$" + _vm._s(_vm.transaction.amount))
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { "justify-center": "" } },
                      [
                        _c("v-flex", { attrs: { md4: "" } }, [
                          _vm._v(_vm._s(_vm.$t("depositAmount")))
                        ]),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { md4: "" } }, [
                          _vm._v("$" + _vm._s(_vm.transaction.depositAmount))
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { "justify-center": "" } },
                      [
                        _c("v-flex", { attrs: { md4: "" } }, [
                          _vm._v(_vm._s(_vm.$t("depositorName")))
                        ]),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { md4: "" } }, [
                          _vm._v(_vm._s(_vm.transaction.depositorName || "---"))
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { "justify-center": "" } },
                      [
                        _c("v-flex", { attrs: { md4: "" } }, [
                          _vm._v(_vm._s(_vm.$t("transactionId")))
                        ]),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { md4: "" } }, [
                          _vm._v(
                            _vm._s(_vm.transaction.transactionKey || "---")
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { "justify-center": "" } },
                      [
                        _c("v-flex", { attrs: { md4: "" } }, [
                          _vm._v(_vm._s(_vm.$t("transactionTime")))
                        ]),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { md4: "" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.transaction.createTime instanceof Date
                                ? _vm.toTimestampString(
                                    _vm.transaction.createTime
                                  )
                                : "---"
                            )
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { "justify-center": "" } },
                      [
                        _c("v-flex", { attrs: { md4: "" } }, [
                          _vm._v(_vm._s(_vm.$t("note")))
                        ]),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { md4: "" } }, [
                          _vm._v(_vm._s(_vm.transaction.note || "---"))
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.transaction.subtype === "other service"
              ? _c(
                  "v-container",
                  { attrs: { fluid: "" } },
                  [
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs5: "", md4: "", lg3: "", xl2: "" } },
                          [_vm._v(_vm._s(_vm.$t("serviceFee")) + ": ")]
                        ),
                        _vm._v(" "),
                        _c("v-flex", [
                          _vm._v(
                            "$ " + _vm._s(_vm.toMoney(_vm.transaction.amount))
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs6: "", md4: "", lg3: "", xl2: "" } },
                          [_vm._v(_vm._s(_vm.$t("note")) + ": ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          {
                            staticStyle: {
                              "white-space": "pre-wrap",
                              overflow: "auto"
                            },
                            attrs: { xs6: "", md8: "", lg9: "", xl10: "" }
                          },
                          [_vm._v(_vm._s(_vm.transaction.note))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      _vm._l(_vm.transaction.attachments || [], function(
                        file,
                        index
                      ) {
                        return _c("FsFileChip", {
                          key: "file" + index,
                          staticClass: "ma-2",
                          attrs: {
                            file: file,
                            width: "100%",
                            "aspect-ratio": "1.7"
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.allDetails.length
              ? _c(
                  "v-container",
                  { attrs: { fluid: "" } },
                  [
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", md8: "", lg6: "", xl4: "" } },
                          [
                            _vm.allDetails.length > 1
                              ? _c("v-select", {
                                  attrs: {
                                    items: _vm.allDetails,
                                    "item-text": "labelKey",
                                    "return-object": "",
                                    label: _vm.$t("labelId")
                                  },
                                  model: {
                                    value: _vm.details,
                                    callback: function($$v) {
                                      _vm.details = $$v
                                    },
                                    expression: "details"
                                  }
                                })
                              : _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t("labelId"),
                                    readonly: "",
                                    value: _vm.allDetails[0].labelKey
                                  }
                                })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.details.requestId
                      ? [
                          _vm.details.trackingNumber
                            ? _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        "pr-4": "",
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: "",
                                        "text-xs-right": ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("trackingNumber")) + ": "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: ""
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.details.trackingNumber))]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.details.invoiceDate
                            ? _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        "pr-4": "",
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: "",
                                        "text-xs-right": ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("invoiceDate")) + ": "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: ""
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.details.invoiceDate))]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.details.estimatedDelivery
                            ? _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        "pr-4": "",
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: "",
                                        "text-xs-right": ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("estimatedDelivery")) +
                                          ": "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.toDateYYYYMMDDHHmm(
                                            new Date(
                                              _vm.toLocalDateString(
                                                _vm.details.estimatedDelivery
                                              )
                                            )
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.details.invoiceNumber
                            ? _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        "pr-4": "",
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: "",
                                        "text-xs-right": ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("invoiceNumberType")) +
                                          ": "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.details.invoiceNumber) +
                                          " / " +
                                          _vm._s(_vm.details.type)
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-center": "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  attrs: {
                                    "pr-4": "",
                                    xs6: "",
                                    md6: "",
                                    lg5: "",
                                    xl3: "",
                                    "text-xs-right": "",
                                    "justify-center": ""
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("serviceType")) + ": ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  attrs: { xs6: "", md6: "", lg5: "", xl3: "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.details.serviceDescription ||
                                        _vm.details.actualServiceType
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.details.weight
                            ? _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        "pr-4": "",
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: "",
                                        "text-xs-right": ""
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("weight")) + ": ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.details.originWeight ||
                                            _vm.details.weight
                                        ) +
                                          _vm._s(
                                            _vm.details.isMeasurementMetric
                                              ? "kg"
                                              : "lbs"
                                          )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.details.actualWeight
                            ? _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        "pr-4": "",
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: "",
                                        "text-xs-right": ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("actualWeight")) + ": "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.details.actualWeight) +
                                          " lbs"
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.details.billingWeight || _vm.details.invoiceWeight
                            ? _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        "pr-4": "",
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: "",
                                        "text-xs-right": ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("billingWeight")) + ": "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.details.billingWeight ||
                                            _vm.details.invoiceWeight
                                        ) + " lbs"
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-center": "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  attrs: {
                                    "pr-4": "",
                                    xs6: "",
                                    md6: "",
                                    lg5: "",
                                    xl3: "",
                                    "text-xs-right": ""
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("dimensions")) + ": ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  attrs: { xs6: "", md6: "", lg5: "", xl3: "" }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.details.actualLength ||
                                          _vm.details.originLength ||
                                          _vm.details.length ||
                                          (_vm.details.packages &&
                                            (_vm.details.packages[0]
                                              .originLength ||
                                              _vm.details.packages[0].length))
                                      ) +
                                      _vm._s(
                                        _vm.details.isMeasurementMetric
                                          ? "cm"
                                          : '"'
                                      ) +
                                      "/\n            " +
                                      _vm._s(
                                        _vm.details.actualWidth ||
                                          _vm.details.originWidth ||
                                          _vm.details.width ||
                                          (_vm.details.packages &&
                                            (_vm.details.packages[0]
                                              .originWidth ||
                                              _vm.details.packages[0].width))
                                      ) +
                                      _vm._s(
                                        _vm.details.isMeasurementMetric
                                          ? "cm"
                                          : '"'
                                      ) +
                                      "/\n            " +
                                      _vm._s(
                                        _vm.details.actualHeight ||
                                          _vm.details.originHeight ||
                                          _vm.details.height ||
                                          (_vm.details.packages &&
                                            (_vm.details.packages[0]
                                              .originHeight ||
                                              _vm.details.packages[0].height))
                                      ) +
                                      _vm._s(
                                        _vm.details.isMeasurementMetric
                                          ? "cm"
                                          : '"'
                                      ) +
                                      "\n            "
                                  ),
                                  _vm.detailPackages.length
                                    ? _c(
                                        "v-icon",
                                        {
                                          staticStyle: { cursor: "pointer" },
                                          attrs: { small: "", color: "info" },
                                          on: { click: _vm.showPackageDetails }
                                        },
                                        [_vm._v("info")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.details.from || _vm.details.shipper
                            ? _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        "pr-4": "",
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: "",
                                        "text-xs-right": ""
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("shipper")) + ": ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatContact(
                                            _vm.details.from ||
                                              _vm.details.shipper
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.details.to || _vm.details.recipient
                            ? _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        "pr-4": "",
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: "",
                                        "text-xs-right": ""
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("recipient")) + ": ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatContact(
                                            _vm.details.to ||
                                              _vm.details.recipient ||
                                              _vm.details.originalRecipient
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.details.zone || _vm.details.actualZone
                            ? _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        "pr-4": "",
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: "",
                                        "text-xs-right": ""
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("zone")) + ": ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.details.zone ||
                                            _vm.details.actualZone
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.allDetails.length === 1 ||
                          _vm.details.sequenceNumber === 1
                            ? _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        "pr-4": "",
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: "",
                                        "text-xs-right": ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("shipmentWeight")) + ": "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.details.shipmentWeight ||
                                            _vm.details.weight ||
                                            (_vm.details.packages &&
                                              _vm.details.packages[0].weight)
                                        ) + " lbs"
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.allDetails.length === 1 ||
                          _vm.details.sequenceNumber === 1
                            ? _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        "pr-4": "",
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: "",
                                        "text-xs-right": ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("shipmentBillingWeight")
                                        ) + ": "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs6: "",
                                        md6: "",
                                        lg5: "",
                                        xl3: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.details.shipmentBillingWeight ||
                                            _vm.details.billingWeight
                                        ) + " lbs"
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.allDetails.length === 1 ||
                          _vm.details.sequenceNumber === 1
                            ? [
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-center": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: {
                                          "pr-4": "",
                                          xs6: "",
                                          md6: "",
                                          lg5: "",
                                          xl3: "",
                                          "text-xs-right": ""
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              _vm.isCancelHandleFee
                                                ? "handleFee"
                                                : "discountedPostageAmount"
                                            )
                                          ) + ": "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: {
                                          xs6: "",
                                          md6: "",
                                          lg5: "",
                                          xl3: ""
                                        }
                                      },
                                      [_vm._v("$" + _vm._s(_vm.postageAmount))]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.details.discount
                                  ? _c(
                                      "v-layout",
                                      { attrs: { "justify-center": "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: {
                                              "pr-4": "",
                                              xs6: "",
                                              md6: "",
                                              lg5: "",
                                              xl3: "",
                                              "text-xs-right": ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("discountLower")) +
                                                ": "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: {
                                              xs6: "",
                                              md6: "",
                                              lg5: "",
                                              xl3: ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.details.discount) +
                                                "% off"
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.detailSurcharges, function(
                                  amount,
                                  name
                                ) {
                                  return _c(
                                    "v-layout",
                                    {
                                      key: name,
                                      attrs: { "justify-center": "" }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: {
                                            "pr-4": "",
                                            xs6: "",
                                            md6: "",
                                            lg5: "",
                                            xl3: "",
                                            "text-xs-right": ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("surcharge")) +
                                              " - " +
                                              _vm._s(name) +
                                              ": "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: {
                                            xs6: "",
                                            md6: "",
                                            lg5: "",
                                            xl3: ""
                                          }
                                        },
                                        [_vm._v("$" + _vm._s(amount))]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                _vm._v(" "),
                                _vm.details.invoiceNumber
                                  ? _c(
                                      "v-layout",
                                      { attrs: { "justify-center": "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: {
                                              "pr-4": "",
                                              xs6: "",
                                              md6: "",
                                              lg5: "",
                                              xl3: "",
                                              "text-xs-right": ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("totalAmount")) +
                                                ": "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: {
                                              xs6: "",
                                              md6: "",
                                              lg5: "",
                                              xl3: ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "$" +
                                                _vm._s(
                                                  _vm.getTotalAmount(
                                                    _vm.details
                                                      .actualAmountDetails,
                                                    _vm.details.discount
                                                  )
                                                )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-layout", { attrs: { "my-2": "" } }, [_c("hr")]),
                          _vm._v(" "),
                          _vm.details.sequenceNumber === 1
                            ? [
                                _vm.details.invoiceNumber
                                  ? _c(
                                      "v-layout",
                                      { attrs: { "justify-center": "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: {
                                              "pr-4": "",
                                              xs6: "",
                                              md6: "",
                                              lg5: "",
                                              xl3: "",
                                              "text-xs-right": ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("difference")) +
                                                ": "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: {
                                              xs6: "",
                                              md6: "",
                                              lg5: "",
                                              xl3: ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "$" +
                                                _vm._s(-_vm.transaction.amount)
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.transaction.discount
                                  ? _c(
                                      "v-layout",
                                      { attrs: { "justify-center": "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: {
                                              "pr-4": "",
                                              xs6: "",
                                              md6: "",
                                              lg5: "",
                                              xl3: "",
                                              "text-xs-right": ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("VIPDiscount")) +
                                                ": "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: {
                                              xs6: "",
                                              md6: "",
                                              lg5: "",
                                              xl3: ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.transaction.discount) +
                                                "%"
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.details.orderId
                                  ? _c(
                                      "v-layout",
                                      { attrs: { "justify-center": "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: {
                                              "pr-4": "",
                                              xs6: "",
                                              md6: "",
                                              lg5: "",
                                              xl3: "",
                                              "text-xs-right": ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.isCancelHandleFee
                                                    ? "handleFee"
                                                    : "totalAmount"
                                                )
                                              ) + ": "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: {
                                              xs6: "",
                                              md6: "",
                                              lg5: "",
                                              xl3: ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "$" +
                                                _vm._s(_vm.details.totalAmount)
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.details.invoiceNumber
                            ? _c("v-data-table", {
                                staticClass: "elevation-1",
                                attrs: {
                                  headers: _vm.detailsHeaders,
                                  items: _vm.details.packages,
                                  "hide-actions": ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "items",
                                      fn: function(ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-left" },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(item.trackingNumber) +
                                                  "\n            "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-left" },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    (item.length ||
                                                      item.actualLength) +
                                                      " x " +
                                                      (item.width ||
                                                        item.actualWidth) +
                                                      " x " +
                                                      (item.height ||
                                                        item.actualHeight)
                                                  ) +
                                                  "\n            "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-left" },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    item.billingWeight ||
                                                      item.weight ||
                                                      item.actualWeight
                                                  ) +
                                                  "\n            "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-left" },
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { top: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function(ref) {
                                                          var on = ref.on
                                                          return [
                                                            _c(
                                                              "span",
                                                              _vm._g({}, on),
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.sumObjVal(
                                                                      item.amountDetails
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                },
                                                [
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    _vm._l(
                                                      item.amountDetails,
                                                      function(val, key) {
                                                        return _c(
                                                          "div",
                                                          { key: key },
                                                          [
                                                            _vm._v(
                                                              "\n                    " +
                                                                _vm._s(key) +
                                                                ": " +
                                                                _vm._s(val) +
                                                                "\n                  "
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1089489139
                                )
                              })
                            : _vm._e()
                        ]
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c("SimpleTextPopup", {
              attrs: { title: _vm.$t("package"), hideRgtBtn: "" },
              on: {
                popupClose: function($event) {
                  _vm.isShowPackageDetails = false
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c("v-data-table", {
                        staticClass: "elevation-1",
                        attrs: {
                          headers: [
                            {
                              text: _vm.$t("id#"),
                              align: "left",
                              sortable: false,
                              value: "key"
                            },
                            {
                              text: _vm.$t("dimension"),
                              value: "dimension",
                              align: "left",
                              sortable: false
                            },
                            {
                              text: _vm.$t("weight"),
                              value: "weight",
                              align: "left",
                              sortable: false
                            },
                            {
                              text: _vm.$t("billingWeight"),
                              value: "billingWeight",
                              align: "left",
                              sortable: false
                            },
                            {
                              text: _vm.$t("qty"),
                              value: "qty",
                              align: "left",
                              sortable: false
                            }
                          ],
                          items: _vm.detailPackages,
                          "hide-actions": ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "items",
                            fn: function(props) {
                              return [
                                _c("td", { staticClass: "subheading" }, [
                                  _vm._v(_vm._s(props.index + 1))
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(props.item.dimension))
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(props.item.weight) + " lbs")
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(props.item.billingWeight) + " lbs"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(props.item.qty))])
                              ]
                            }
                          }
                        ])
                      })
                    ]
                  },
                  proxy: true
                }
              ]),
              model: {
                value: _vm.isShowPackageDetails,
                callback: function($$v) {
                  _vm.isShowPackageDetails = $$v
                },
                expression: "isShowPackageDetails"
              }
            })
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e687c78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e687c78","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BillingTransactionDetail.vue
// module id = null
// module chunks = 